import React, { FC } from 'react';
import { Box, Stack, Typography, useTheme } from '@mui/material';

import typography from '@/theme/typography';

interface LegendItemProps {
  color: string;
  title: string;
  value?: string;
}

const LegendItem: FC<LegendItemProps> = ({ color, title, value }) => {
  const { spacing } = useTheme();

  return (
    <Stack direction="row" p={0.25} gap={0.5} alignItems="center">
      <Box sx={{ bgcolor: color, width: spacing(1.5), height: spacing(1.5), borderRadius: spacing(0.25) }} />
      <Typography sx={{ ...typography.body3, color: 'grey.700' }}>{title}</Typography>
      <Typography sx={{ ...typography.body3, fontWeight: typography.fontWeightMedium, color: 'grey.700' }}>
        {value}
      </Typography>
    </Stack>
  );
};
export default LegendItem;
